import {useContext} from 'react';
import classnames from 'classnames';
import axios from 'axios';
import {StoreContext} from '../../StoreProvider';
import useTracking from '../../hooks/useTracking';

const OverlayVideoRouter = ({overlay}) => {
    const {contentParams}          = overlay;
    const {setCustomerData}        = useContext(StoreContext);
    const {sendBeacon}             = useTracking();
    const {settings, customerData} = useContext(StoreContext);

    const classes = classnames('overlay-videorouter', contentParams.className);

    const onRouteClick = async (route) => {
        if (!route.route_uri) {
            return;
        }

        const apiBase = settings.cdn || 'https://api.thevideogram.com';
        const urlRoute = `${apiBase}/events/routes/${settings.tenantId}/${settings.scenarioId}`;
        sendBeacon('VIDEO_ROUTE_CLICKED', {
            from: overlay.id,
            to  : route.id
        }, urlRoute);

        if (route.interaction) {
            const urlInteraction = `${apiBase}/events/interactions/${settings.tenantId}/${settings.scenarioId}`;
            sendBeacon('INTERACTION', {
                event_data: route.interaction.event_data
            }, route.interaction.uri || urlInteraction);
        }

        try {
            const response = await axios.get(route.route_uri);
            setCustomerData(response.data);
        } catch (e) {
            console.error(e);
        }
    }

    return (
        <div className={classes}>
            <div className="overlay-videorouter__content">
                {contentParams.routes ? (
                    <>
                        {contentParams.routes.map((route, index) => {
                            return (
                                <button
                                    onClick={() => onRouteClick(route)}
                                    className={`overlay-videorouter__route ${route.className ? route.className : ''}`}
                                    key={index}
                                    dangerouslySetInnerHTML={{__html: route.text}}
                                />
                            )
                        })}
                    </>
                ) : null}
            </div>
        </div>
    )
}

export default OverlayVideoRouter
